import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import React from 'react';
import styled from 'styled-components';

import { getCheckoutUrl, getCheckoutUrlATG, getReviewUrl } from '@/utils/urls';

export type WonItemsCardLinksProps = {
    atgPayActive: boolean;
    bidderIsSuspended: boolean;
    catalogId: number;
    invoiceId: number;
    isLivePayments: boolean;
    paidStatus: string;
    reviewLink: React.ReactNode;
    reviewed: boolean;
    sent: boolean;
    showGetHelpModal?: () => void;
};

const WonItemsCardLinks = ({
    atgPayActive,
    bidderIsSuspended,
    catalogId,
    isLivePayments,
    paidStatus,
    reviewed,
    reviewLink,
    sent,
    showGetHelpModal,
}: WonItemsCardLinksProps) => {
    return (
        <>
            {paidStatus === 'paid' && sent && isLivePayments && (
                <StyledLinkContainer>
                    <Link
                        route
                        to={atgPayActive ? getCheckoutUrlATG(catalogId) : getCheckoutUrl(catalogId)}
                    >
                        <FormattedMessage id="view_order_details" />
                    </Link>
                </StyledLinkContainer>
            )}
            <StyledLinkContainer>
                <Link
                    onClick={showGetHelpModal}
                    to=""
                >
                    <FormattedMessage id="support_center" />
                </Link>
            </StyledLinkContainer>
            {!bidderIsSuspended && React.isValidElement(reviewLink) && <div>{reviewLink}</div>}
            {reviewed && (
                <StyledLinkContainer>
                    <Link
                        route
                        to={getReviewUrl(catalogId)}
                    >
                        <FormattedMessage id="read_review" />
                    </Link>
                </StyledLinkContainer>
            )}
        </>
    );
};

export default WonItemsCardLinks;

const StyledLinkContainer = styled.section`
    margin-bottom: 8px;
`;
